import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e60da37"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-info-list" }
const _hoisted_2 = { class: "xag-flex service-type" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "可选服务", -1))
const _hoisted_4 = { class: "value" }
const _hoisted_5 = {
  key: 0,
  class: "xag-flex"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "定责结果", -1))
const _hoisted_7 = { class: "value liabilityResultp-value" }
const _hoisted_8 = { class: "xag-flex y-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "view-btn xag-flex y-center" }, [
  /*#__PURE__*/_createTextVNode("查看 "),
  /*#__PURE__*/_createElementVNode("i", { class: "icon-right-green-svg" })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "xag-flex" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "权益提醒", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = {
  key: 0,
  class: "rights-list"
}
const _hoisted_15 = { class: "xag-flex y-center" }
const _hoisted_16 = { class: "view-btn" }
const _hoisted_17 = {
  key: 1,
  style: {"color":"rgba(0, 0, 0, 0.44)"}
}

import { useRouter } from 'vue-router'
import { xcareTypeClassNameMap } from '../service-tag'
import { withDefaults, onMounted, computed } from 'vue'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair'
import { MalfunctionRepairRepairOrderQualitativeInfoFront } from '@/types/malfunction-repair'
import BlockkWrapper from '../block-wrap.vue'
import ServiceTag from '../service-tag.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'detail-serivce-info-block',
  props: {
    guid: { default: '' },
    repair_sn: { default: '' },
    detail: null,
    serviceGuid: { default: '' },
    serviceNo: null,
    isPlant: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { guid: string, repair_sn: string, detail: MalfunctionRepairRepairOrderQualitativeInfoFront, serviceGuid: string, serviceNo: string, isPlant: boolean };

const $router = useRouter()


const { addOrderRepairDetailItemKeepAlive } = useMalfunctionRepairStore()
//const repairDetail: Ref<null | MalfunctionRepairRepairOrderQualitativeInfo> = ref(null)
const repairDetail = computed(() => {
  if (!props.detail) {
    return null
  }
  return props.detail
})
const rightsList = computed(() => {
  if (!repairDetail.value) {
    return []
  }
  let list = repairDetail?.value.display.filter(_ => _.type !== 'responsibility').map((item) => {
    return {
      ...item,
      iconClass: item.status === 1 ? 'icon-rights-success-svg' : 'icon-rights-warn-svg',
      color: item.status === 1 ? 'rgba(0, 0, 0, 0.88)' : '#f7981c',
      show: !!item.show,
    }
  })
  return list
})

const liabilityResult = computed(() => {
  if (!repairDetail.value) {
    return null
  }
  let item = repairDetail?.value.display.filter(_ => _.type === 'responsibility').map((item) => ({
    ...item,
    iconClass: item.status === 1 ? 'icon-rights-success-svg' : 'icon-rights-warn-svg',
    color: item.status === 1 ? 'rgba(0, 0, 0, 0.88)' : '#f7981c',
    show: !!item.show,
  }))
  return item[0] ? item[0] : null
})

const flyInfo = computed(() => {
  return repairDetail.value?.['72_fly']
})
const flyInfoTextStyle = computed(() => {
  const data = flyInfo.value
  return {
    color: data.text.indexOf('不通过') !== -1 ? '#F85359' : '#f7981c',
  }
})
// async function initData() {
//   try {
//     let data = props.detail
//   } catch (error) {
//     console.log('error', error)
//   }
// }
function toOvertimeAppeal() {
  addOrderRepairDetailItemKeepAlive()
  setTimeout(() => {
    $router.push({
      name: 'malfunction-repair-repair-order-overtime-appeal',
      query: {
        first: flyInfo.value.can_appeal && !flyInfo.value.text ? '1' : '0',
        guid: props.guid,
        repair_sn: props.serviceNo,
        serviceGuid: props.serviceGuid,
        isPlant: String(props.isPlant)
      },
    })
  }, 50)
}
function toDutyResult() {
  addOrderRepairDetailItemKeepAlive()
  setTimeout(() => {
    $router.push({
      name: 'malfunction-repair-repair-order-duty-result',
      query: {
        guid: props.serviceGuid,
        isPlant:String(props.isPlant)
      },
    })
  }, 50)
}
onMounted(() => {
  // initData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockkWrapper, { title: "维修服务情况" }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        _createElementVNode("li", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(ServiceTag, {
              "service-type": props.detail.service_type
            }, null, 8, ["service-type"])
          ])
        ]),
        (_unref(liabilityResult) && _unref(liabilityResult).show)
          ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["i-tag", _unref(liabilityResult).iconClass])
                  }, null, 2),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ color: _unref(liabilityResult).color })
                  }, _toDisplayString(_unref(liabilityResult).title), 5)
                ]),
                _createElementVNode("div", {
                  class: "operate",
                  onClick: toDutyResult
                }, _hoisted_10)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            (_unref(rightsList).length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rightsList), (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.type
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("i", {
                          class: _normalizeClass(item.iconClass)
                        }, null, 2),
                        _createElementVNode("div", {
                          style: _normalizeStyle({ color: item.color })
                        }, _toDisplayString(item.title), 5)
                      ]),
                      (item.type === 'fly')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "operate",
                            onClick: toOvertimeAppeal
                          }, [
                            (_unref(flyInfo)?.text)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  style: _normalizeStyle(_unref(flyInfoTextStyle))
                                }, _toDisplayString(_unref(flyInfo).text) + "，", 5))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(flyInfo)?.can_appeal && !_unref(flyInfo).text ? '点击申诉' : '点击查看'), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_17, "-"))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})